// src/components/FeedTabs.jsx
import React from 'react';
import { COUNTRIES } from '../config/feeds';
import { useI18n } from '../i18n';
import { Clock, TrendingUp, Users, Bookmark } from 'lucide-react';

// Map feed IDs to icons
const FEED_ICONS = {
  recent: Clock,
  trending: TrendingUp,
  officials: Users,
  saved: Bookmark,
};

const FeedTabs = ({ activeTab, onTabChange, country = 'US' }) => {
  const { t } = useI18n();
  const feeds = COUNTRIES[country]?.feeds || COUNTRIES.US.feeds;

  // Filter out feeds with empty URIs (except saved which uses null intentionally)
  const availableFeeds = Object.values(feeds).filter(
    feed => feed.id === 'saved' || feed.uri
  );

  // Get translated tab names
  const getTabLabel = (feedId) => {
    return t(`tabs.${feedId}`) || feedId;
  };

  return (
    <nav className="feed-tabs" role="navigation" aria-label="Feed navigation">
      {availableFeeds.map((feed) => {
        const IconComponent = FEED_ICONS[feed.id] || Clock;
        return (
          <button
            key={feed.id}
            className={`feed-tab ${activeTab === feed.id ? 'active' : ''}`}
            onClick={() => onTabChange(feed)}
            aria-current={activeTab === feed.id ? 'page' : undefined}
            role="tab"
            aria-selected={activeTab === feed.id}
          >
            <span className="tab-icon" aria-hidden="true">
              <IconComponent size={16} />
            </span>
            {getTabLabel(feed.id)}
          </button>
        );
      })}
    </nav>
  );
};

export { FeedTabs };
